import request from "api/request";

export const fetchInternshipCards = (auth) => request({
  url: 'api/v2/card/?exp_type=Intership',
  method: 'GET',
  auth
});
